import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6">
        <div className="flex h-16 md:h-[74px] items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-black">
              雷
            </span>
            <span className="leading-none">
              <span className="block font-heading text-xl md:text-2xl font-black tracking-tight text-foreground-950">
                51大雷
              </span>
              <span className="block text-[10px] md:text-[11px] font-medium tracking-[0.28em] text-foreground-500 mt-1">
                翻车现场馆
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.hash}
                href={link.hash}
                className="relative px-4 py-2 text-sm font-medium text-foreground-700 rounded-full hover:text-foreground-950 hover:bg-background-100 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <span className="flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1.5 text-xs font-semibold whitespace-nowrap">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-accent-500 animate-ping opacity-60" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
              </span>
              正在围观
            </span>
            <a
              href="#join"
              className="flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm font-semibold whitespace-nowrap hover:bg-primary-600"
            >
              <i className="ri-add-line text-base" />
              投稿线索
            </a>
          </div>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.hash}
                href={link.hash}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 rounded-lg hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#join"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2.5 text-sm font-semibold"
          >
            <i className="ri-add-line text-base" />
            投稿线索
          </a>
        </div>
      )}
    </header>
  );
}